import { render, staticRenderFns } from "./CompanyDetail.vue?vue&type=template&id=b7eaea32&scoped=true&"
import script from "./CompanyDetail.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDetail.vue?vue&type=style&index=0&id=b7eaea32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7eaea32",
  null
  
)

export default component.exports